import angular from 'angular';

angular
  .module('cloudX')
  .controller('DeleteEmployeeDialogCtrl', [
    'close',
    '$element',
    'resourceFactorySvc',
    'licensingSvc',
    'dataCache',
    'flySvc',
    'employeeId',
    'userId',

    deleteEmployeeDialogCtrl,
  ]);

function deleteEmployeeDialogCtrl(
  close,
  $element,
  resourceFactorySvc,
  licensingSvc,
  dataCache,
  flySvc,
  employeeId,
  userId,
) {
  const vm = this;
  vm.keepVisible = true;
  vm.saving = false;

  vm.save = () => {
    if (vm.saving) return;
    vm.saving = true;
    resourceFactorySvc.get('employee').delete(
      {
        id: employeeId,
        hidden: !vm.keepVisible,
      },
      function(data) {
        var cached = userId ? dataCache.getObject('user')[userId] : null;
        if (cached) {
          cached.hidden = !vm.keepVisible;
          cached.isActive = false;
        }
        licensingSvc.reloadLicenseInformation();
        flySvc.success('msgEmpRemoved');
        vm.saving = false;
        close(data);
        $element.modal('hide');
      },
      function(error) {
        flySvc.error(error);
        vm.saving = false;
      },
    );
  };
  vm.cancel = () => {
    close(null, 500);
  };
}
